import { h } from '@atomify/jsx';

interface TextareaProps {
    label: string | Text | null;
    id: string;
    name: string;

    required?: boolean;
    value?: string;
    classes?: string;
    disabled?: boolean;
    sronly?: boolean;
    attr?: { [key: string]: string };
    error?: string;
    hook?: string;
    labelFloating?: boolean;
}

export const TextareaElement = ({
    label,
    id,
    name,
    required,
    value,
    classes,
    disabled,
    sronly,
    attr = {},
    hook,
    error,
    labelFloating = true,
}: TextareaProps) => {
    let textareaClasses = 'c-textarea form__item';
    if (disabled) textareaClasses += ' form__item--disabled';
    if (classes) textareaClasses += ` ${classes}`;

    const attributes: { [key: string]: boolean | string } = attr || {};
    if (required) attributes.required = true;
    if (value) attributes['bind-value'] = value;

    const labelClass = {
        ['u-sr-only']: sronly,
        ['textarea__label']: labelFloating,
        ['u-body-normal-bold u-margin-bottom-1']: !labelFloating,
    };

    const inputClass = {
        ['textarea__input']: true,
        ['u-margin-top-1']: !labelFloating,
    };

    return (
        <bpd-input {...attributes}>
            <div class={textareaClasses}>
                <div class="textarea__wrapper" title={label}>
                    <label class={labelClass} for={id}>
                        {label}
                    </label>
                    <textarea
                        class={inputClass}
                        name={name}
                        id={id}
                        {...{
                            disabled,
                            required,
                            [`js-hook-${hook || ''}`]: !!hook,
                            ...attr,
                        }}></textarea>
                    <span class="focus-helper"></span>
                </div>

                {error && (
                    <div class="form__item-error" role="alert">
                        {error}
                    </div>
                )}
            </div>
        </bpd-input>
    );
};
